/**
 * Motion Design Tokens — macOS 감성 기반 이징/타이밍 상수
 *
 * Quick  180ms — 버튼 호버, 세그먼트 전환
 * Standard 320ms — 페이지 전환, 카드 호버
 * Generous 520ms — 사이드바 reveal, 큰 모달
 */

export const MOTION_TOKENS = {
  /** 지속 시간 (초 단위 — GSAP는 s 기준) */
  duration: {
    quick: 0.18,
    standard: 0.32,
    generous: 0.52,
  },

  /** GSAP ease 문자열 */
  ease: {
    /** macOS 기본감: power2.out */
    default: 'power2.out' as const,
    /** 카드 스프링 호버: back.out(1.4) */
    spring: 'back.out(1.4)' as const,
    /** 반복 펄스: sine.inOut */
    pulse: 'sine.inOut' as const,
    /** 퇴장 애니메이션 */
    exit: 'power2.in' as const,
  },

  /** 스태거 간격 (초) */
  stagger: {
    /** 사이드바 아이템 — 촘촘 */
    tight: 0.04,
    /** 페이지 진입 — 표준 */
    standard: 0.06,
    /** 넓은 그리드 */
    loose: 0.10,
  },
} as const;

export type MotionDuration = keyof typeof MOTION_TOKENS.duration;
export type MotionEase = keyof typeof MOTION_TOKENS.ease;
export type MotionStagger = keyof typeof MOTION_TOKENS.stagger;
